export enum Role {
  // define the roles this way will allow the compiler check in mappings
  InternalAdmin = 'Admin',
  InternalUser = 'User',
  ExternalEmployer = 'ExternalEmployer',
  ExternalEmployee = 'ExternalEmployee',
  AnonymousUser = 'Anonymous',
}
